import { Component, h } from 'preact'
import { IdeaStatus } from '../../ideation-status/Types'
import Phrase from '../../../libs/translationsUtils/phrase'
import InputGroup from '../../ui-components/InputGroup'
import qs from 'qs'

interface Props {
  ideationStatuses: Array<IdeaStatus>,
  selectedIdeationStatus: null | string
}

interface State {
  selectedIdeationStatus: null | string
}

export class IdeaStatusFilter extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      selectedIdeationStatus: props.selectedIdeationStatus === null ? null : props.selectedIdeationStatus
    }
    this.setQueryParams = this.setQueryParams.bind(this)
    this.setSelectedIdeationStatus = this.setSelectedIdeationStatus.bind(this)
  }

  setQueryParams (newStatus: string | null) {
    const searchQuery = window.location.search
    let queryParameters = qs.parse(searchQuery, { ignoreQueryPrefix: true })

    delete queryParameters?.filters?.ideationStatus

    let newQuery = newStatus === null ? { filters: queryParameters?.filters || {} } : { filters: { ...queryParameters?.filters || {}, ideationStatus: [newStatus] } }

    let combinedQuery = { ...queryParameters, ...newQuery }

    delete combinedQuery?.page

    window.history.pushState('', '', `?${qs.stringify(combinedQuery)}`)
  }

  setSelectedIdeationStatus (newStatus: string | null) {
    this.setState({ selectedIdeationStatus: newStatus })
    this.setQueryParams(newStatus)
  }

  render ({ ideationStatuses }: Props, { selectedIdeationStatus }: State) {
    return (
      <div className='box__content box__pad ideation-filters'>
        <h3 className='widget-title'><Phrase p='filter.by.idea.status' /></h3>
        <ul className='ideation-filters__idea-status'>
          <li className={selectedIdeationStatus === null ? 'selected' : ''} onClick={() => this.setSelectedIdeationStatus(null)}>
            <div className='vertical-line' />
            <Phrase p='all.statuses' />
          </li>
          {
            ideationStatuses.map(({ name }) => (
              <li className={selectedIdeationStatus === name ? 'selected' : ''} onClick={() => this.setSelectedIdeationStatus(name)}>
                <div className='vertical-line' />
                <span>{ name }</span>
              </li>
            ))
          }
        </ul>
      </div>
    )
  }
}

interface PropsForConfigurator {
  title: string,
  onChange: (state: {title: string}) => void
}

interface StateForConfigurator {
  title: string
}

export class IdeaStatusFilterWithHelp extends Component<PropsForConfigurator, StateForConfigurator> {
  constructor (props: PropsForConfigurator) {
    super(props)
    this.state = {
      title: props.title
    }

    this.onChangeTitle = this.onChangeTitle.bind(this)
  }

  onChangeTitle (newTitle: string) {
    this.setState({ title: newTitle }, () => this.props.onChange(this.state))
  }

  render (_: PropsForConfigurator, { title }: StateForConfigurator) {
    return (
      <div className=''>
        <InputGroup
          title='Title'
          name='title'
          placeholder='Add a title'
          type='text'
          onChange={(e: {target: HTMLInputElement}) => { this.onChangeTitle(e.target.value) }}
          value={title} />
      </div>
    )
  }
}

export default IdeaStatusFilter
